import { TokenName } from "../hooks/useFarmsList";
import React, { CSSProperties, useMemo } from "react";

interface Props {
  token: TokenName;
  style?: CSSProperties;
}

export const TokenIcon: React.FunctionComponent<Props> = ({ token, style }) =>
  useMemo(() => {
    switch (token) {
      case "REF":
      case "REF-NEAR":
        return (
          <img style={style} src="./icons/ref.png" height={28} width={28} />
        );
      case "NEAR":
        return (
          <img style={style} src="./icons/near.png" height={28} width={28} />
        );
      case "USDC":
        return (
          <img style={style} src="./icons/usdc.svg" height={28} width={28} />
        );
      case "USDT":
        return (
          <img style={style} src="./icons/usdt.png" height={28} width={28} />
        );
      case "Metapool stNEAR":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 67.79 67.79"
            width="28"
            height="28"
            version="1.1"
          >
            <path
              fill="#fff"
              d="M33.934.311a33.9 33.9 0 1 0 33.89 33.9 33.9 33.9 0 0 0-33.89-33.9z"
              id="path505"
            />
            <path
              stroke="none"
              fill="#ffbd00"
              strokeWidth="1px"
              strokeLinecap="butt"
              strokeLinejoin="miter"
              strokeOpacity={1}
              fillOpacity={1}
              d="m11.803 27.8 12.387.359 2.361 5.959 7.616 3.31 8.523-3.322 2.348-5.87 12.269.03L54.822 54.2 31.837 58.86 12.89 52.648z"
              id="path1051"
            />
            <path
              stroke="none"
              fill="#a0a0ff"
              strokeWidth="1px"
              strokeLinecap="butt"
              strokeLinejoin="miter"
              strokeOpacity={1}
              fillOpacity={1}
              d="m34.657 12.575-10.43 9.633 1.096 10.01 8.844 5.21 9.785-5.287 1.086-11.33z"
              id="path1815"
            />
            <path
              id="path928"
              fill="#666"
              fillOpacity={1}
              d="M33.928 4.282a29.93 29.93 0 0 1 4.682.367 29.93 29.93 0 0 1 25.244 29.572 29.93 29.93 0 0 1-29.92 29.92 29.93 29.93 0 0 1-.006-59.86zm.729 8.293c-2.03 5.668-8.815 9.76-8.815 14.521 0 4.76 3.912 8.62 8.737 8.62 4.824 0 8.736-3.86 8.736-8.62s-6.707-8.697-8.658-14.521zM37.84 22.67a2.524 2.446 0 0 1 .246.012 2.524 2.446 0 0 1 .246.035 2.524 2.446 0 0 1 .24.059 2.524 2.446 0 0 1 .233.08 2.524 2.446 0 0 1 .225.104 2.524 2.446 0 0 1 .213.123 2.524 2.446 0 0 1 .197.142 2.524 2.446 0 0 1 .183.162 2.524 2.446 0 0 1 .168.178 2.524 2.446 0 0 1 .147.191 2.524 2.446 0 0 1 .127.207 2.524 2.446 0 0 1 .105.217 2.524 2.446 0 0 1 .084.227 2.524 2.446 0 0 1 .06.232 2.524 2.446 0 0 1 .038.237 2.524 2.446 0 0 1 .012.24 2.524 2.446 0 0 1-.086.633 2.524 2.446 0 0 1-.252.59 2.524 2.446 0 0 1-.403.507 2.524 2.446 0 0 1-.521.389 2.524 2.446 0 0 1-.61.244 2.524 2.446 0 0 1-.652.084 2.524 2.446 0 0 1-.654-.084 2.524 2.446 0 0 1-.607-.244 2.524 2.446 0 0 1-.524-.389 2.524 2.446 0 0 1-.4-.508 2.524 2.446 0 0 1-.252-.59 2.524 2.446 0 0 1-.086-.632 2.524 2.446 0 0 1 .086-.633 2.524 2.446 0 0 1 .252-.59 2.524 2.446 0 0 1 .4-.506A2.524 2.446 0 0 1 36.58 23a2.524 2.446 0 0 1 .607-.247 2.524 2.446 0 0 1 .654-.082zM24.19 28.16a16.579 2.485 0 0 0-6.502 1.965 16.579 2.485 0 0 0 7.635 2.093 10.483 10.6 0 0 1-1.133-4.058zm20.848.078a10.483 10.6 0 0 1-1.086 3.904 16.579 2.485 0 0 0 6.894-2.017 16.579 2.485 0 0 0-5.808-1.887zm6.925 3.21c-.455 1.177-4.097 2.154-9.273 2.659a10.483 10.6 0 0 1-8.072 3.861 10.483 10.6 0 0 1-8.067-3.85c-5.276-.506-8.978-1.498-9.398-2.64h-.049v5.17h.049a.69.69 0 0 0-.049.24c0 1.8 7.81 3.25 17.43 3.25 9.62 0 17.43-1.45 17.43-3.25a.69.69 0 0 0 0-.24zm.032 7.323c-.67 1.73-8.22 3.03-17.43 3.03-9.23 0-16.771-1.34-17.381-3h-.049v5.17h.049a.69.69 0 0 0-.049.24c0 1.8 7.81 3.25 17.43 3.25 9.62 0 17.43-1.45 17.43-3.25a.69.69 0 0 0 0-.24zm0 7.21c-.67 1.69-8.22 3.03-17.43 3.03-9.23 0-16.771-1.34-17.381-3h-.049v5.17h.049a.69.69 0 0 0-.049.24c0 1.8 7.81 3.25 17.43 3.25 9.62 0 17.43-1.45 17.43-3.25a.69.69 0 0 0 0-.24z"
            />
          </svg>
        );
      default:
        return <img style={style} src="" height={28} width={28} />;
    }
  }, [style, token]);

export default React.memo(TokenIcon);
